import axios from "@/app/plugins/Axios";


function clientes() {
  return axios.get("listas/clientes").then((response) => response.data);
}

function vendedores() {
  return axios.get("listas/vendedores").then((response) => response.data);
}

function fornecedores() {
  return axios.get("listas/fornecedores").then((response) => response.data);
}

function bancos() {
  return axios.get("listas/bancos").then((response) => response.data);
}

function perfis() {
  return axios.get("listas/perfis").then((response) => response.data);
}

function lotes() {
  return axios.get("listas/lotes").then((response) => response.data);
}

function lojas() {
  return axios.get("listas/lojas").then((response) => response.data);
}

function variacoes() {
  return axios.get("listas/variacoes").then((response) => response.data);
}

function grupos() {
  return axios.get('listas/grupos').then(response => response.data);
}

function subgrupos() {
  return axios.get('listas/subgrupos').then(response => response.data);
}

function fetchListas(listas) {
    return axios.post("listas", {'listas': listas}).then((response) => response.data);
}

export default {
  clientes,
  vendedores,
  fornecedores,
  bancos,
  perfis,
  lotes,
  lojas,
  variacoes,
  grupos,
  subgrupos,
  fetchListas
}